<template lang="pug">
div 
    a-modal(title="添加T0收益权重" v-model="addWeightVisible" @ok="addWeight" @cancel="addWeightVisible = false"
        ok-text="添加" cancel-text="取消")
        span 开始时间:
        a-date-picker(v-model="startDate" placeholder="选择日期" style="margin-bottom: 15px;margin-left: 5px")
        a-table(:columns="t0WeightsColumns" 
            size="small"
            bordered
            :data-source="t0Weights" 
            row-key="bookName" 
            :pagination="false")
            template(slot="weight" slot-scope="text, record, index")
                a-input-number(v-model="record.weight" :min="0" :max="1" :step="0.01" :disabled="!record.isSetting")
            template(slot="setting" slot-scope="text, record, index")
                span 设置: 
                a-checkbox(v-model="record.isSetting")



    a-button(type="primary" @click="addWeightVisible = true" style="margin-bottom: 15px")
        a-icon(type="plus")
        span 添加收益权重

    a-timeline 
        a-timeline-item(v-for="w in weights" :key="w[0]")
            div 
                span {{w[0]}}
                a(style="margin-left: 10px" @click="deleteWeight(w[0])")
                    a-icon(type="delete")
            div(v-for="v in w[1]" :key="v._id") 
                span {{v.bookName}}: {{v.weight}}
</template>

<script>
import _ from 'lodash';
import moment from 'moment/moment';

export default {
    data() {
        return {
            t0WeightsColumns: [
                {
                    title: 'BookName',
                    dataIndex: 'bookName',
                    key: 'bookName'
                },
                {
                    title: '权重',
                    dataIndex: 'weight',
                    key: 'weight',
                    scopedSlots: { customRender: 'weight' },
                },
                {
                    title: '是否设置',
                    dataIndex: 'isSetting',
                    key: 'isSetting',
                    scopedSlots: {customRender: 'setting'}
                }
            ],
            startDate: moment(),
            t0Weights: [],
            addWeightVisible: false,
            weights: [],
        }
    },
    mounted() {
        this.getWeights();
        this.getBookNames();
    },
    methods: {
        getBookNames() {
            this.$api.request('GET', 'hkoption/booknames')
                .then(res => {
                    this.t0Weights = res.data.map(i => {
                        return {
                            bookName: i.name,
                            weight: 0,
                            isSetting: false,
                        }
                    });
                })
        },
        addWeight() {
            this.$api.request('POST', 'hkoption/t0Weight', {
                startDate: this.startDate.format("YYYY-MM-DD"),
                weights: this.t0Weights.filter(i => i.isSetting).map(i => {
                    return {
                        bookName: i.bookName,
                        weight: i.weight,
                    }
                })
            })
            .then(res => {
                this.addWeightVisible = false;
                this.getWeights();
            })
            .catch(err => {
                this.$message.error('添加失败:' + err.response.data);
            })
        },
        getWeights() {
            this.$api.request('GET', 'hkoption/t0Weights')
                .then(res => {
                    this.weights = res.data;
                })
        },
        deleteWeight(date) {
            this.$api.request('DELETE', `hkoption/t0Weight/${date}`)
            .then(res => {
                this.getWeights();
            });
        }
    }
}
</script>